import { useMemo } from "react";

import type { DummyRoomNewItem_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import { useInitProductDummyRoomFormModelContext } from "../../../init";
import { serverModelToInputModelConverter } from "./converter/server-model-to-input-model/server-model-to-input-model";
import { useDummyRoomEditMutation } from "../../../repository/new";

import type { ProductNewDummyRoomFormModelContextType } from "../../../../ui/new/context/context";

type Props = {
	onCreateRoomSuccessCallback: () => void;

	serverModel: DummyRoomNewItem_EditPageQuery;
};

export const useInitialized = ({
	onCreateRoomSuccessCallback,
	serverModel,
}: Props): ProductNewDummyRoomFormModelContextType => {
	const inputModel = useMemo(() => serverModelToInputModelConverter(serverModel), [serverModel]);

	const queryData = {
		connection: {
			planNameAndIDOptions: [
				...serverModel.planList.plans.map(
					(plan) => ({ id: plan.id, label: plan.name, value: plan.planID }) satisfies FormOptionType,
				),
				...serverModel.planList.secrets.map(
					(plan) => ({ id: plan.id, label: plan.name, value: plan.planID }) satisfies FormOptionType,
				),
			],
		},
	};

	const { onSetViewModel, viewModel, resetViewModel } = useInitProductDummyRoomFormModelContext({
		inputModel,
		queryData,
	});

	const { onUpdate } = useDummyRoomEditMutation({ resetForm: resetViewModel, onCreateRoomSuccessCallback });

	return {
		queryData,
		onSetViewModel,
		viewModel,
		onUpdate: () => onUpdate({ ...viewModel }),
	};
};
